import { getS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";
import { generateLinkTypeOption } from "../utils/CreatePaymentLinkModal.utils";

export const LINK_TYPES = {
  CUSTOM_LINK: 1,
  OPEN_LINK: 2,
  UNIVERSAL_LINK: 3,
  COMBO_LINK: 4,
};

export const LINK_TYPE_LABELS = {
  [LINK_TYPES.CUSTOM_LINK]: "Fixed Payment Link",
  [LINK_TYPES.OPEN_LINK]: "Flexible Payment Link",
  [LINK_TYPES.UNIVERSAL_LINK]: "Universal Payment Link",
  [LINK_TYPES.COMBO_LINK]: "Combo Package Payment Link",
};

export const LINK_TYPE_ICONS = {
  [LINK_TYPES.OPEN_LINK]: getS3AssetCDNUrl(
    "assets/vectors/checkout-pages/flexible-link.svg"
  ),
  [LINK_TYPES.CUSTOM_LINK]: getS3AssetCDNUrl(
    "assets/vectors/checkout-pages/fixed-link.svg"
  ),
  [LINK_TYPES.COMBO_LINK]: getS3AssetCDNUrl(
    "assets/vectors/checkout-pages/fixed-link.svg"
  ),
};

export const LINK_TYPE_OPTIONS = [
  generateLinkTypeOption({
    title: LINK_TYPE_LABELS[LINK_TYPES.OPEN_LINK],
    description: "Use to create links where your customers can pay any price",
    value: LINK_TYPES.OPEN_LINK,
    icon: LINK_TYPE_ICONS[LINK_TYPES.OPEN_LINK],
  }),
  generateLinkTypeOption({
    title: LINK_TYPE_LABELS[LINK_TYPES.CUSTOM_LINK],
    description:
      "Use to create custom payment links different than the original price",
    value: LINK_TYPES.CUSTOM_LINK,
    icon: LINK_TYPE_ICONS[LINK_TYPES.CUSTOM_LINK],
  }),
  generateLinkTypeOption({
    title: LINK_TYPE_LABELS[LINK_TYPES.COMBO_LINK],
    description: "Use to create combos payment links, for multiple listings",
    value: LINK_TYPES.COMBO_LINK,
    icon: LINK_TYPE_ICONS[LINK_TYPES.COMBO_LINK],
  }),
];

// value represent the page number here, so page values must be in ascending order with the difference of 1
export const CREATE_PAYMENT_LINK_FORM_PAGES = {
  LINK_TYPE_SELECTION: 1,
  FORM_INPUTS: 2,
};

export const CREATE_PAYMENT_LINK_MODAL_TITLES = {
  [LINK_TYPES.OPEN_LINK]: "Create Flexible Payment Page",
  [LINK_TYPES.CUSTOM_LINK]: "Create Fixed Payment Page",
  [LINK_TYPES.COMBO_LINK]: "Create Combo Package Payment Page",
};

export const CREATE_PAYMENT_LINK_MODAL_CTA_LABELS = {
  [CREATE_PAYMENT_LINK_FORM_PAGES.LINK_TYPE_SELECTION]: "Continue",
  [CREATE_PAYMENT_LINK_FORM_PAGES.FORM_INPUTS]: "Create Page",
};

export const FORM_INPUTS_ERROR_MESSAGES = {
  link_name_length: "Title must be between 3 and 100 characters",
  link_price_required: "Price is mandatory",
  link_name_required: "Name is mandatory",
  required: "Required",
};

export const CREATE_PAYMENT_LINK_EVENTS = {
  LINK_CREATED_SUCCESS: 1,
  LINK_UPDATED_SUCCESS: 2,
};

export const CREATE_PAYMENT_LINK_EVENT_MESSAGES = {
  [CREATE_PAYMENT_LINK_EVENTS.LINK_CREATED_SUCCESS]:
    "Dynamic link created. You can see the link in the 'Manage Payment Links' table.",
  [CREATE_PAYMENT_LINK_EVENTS.LINK_UPDATED_SUCCESS]:
    "Payment page has been successfully updated",
};

export const MERCHANDISE_PRODUCT_QUANTITY = "PRODUCT_QUANTITY";

export const BOOKING_FEE_TYPE = {
  CUSTOMER: "customer",
  CREATOR: "creator",
};

export const OFFERING_FIELD_DEFAULT_VALUES = {
  ALLOW_CUSTOMER_DEFAULT: "ALLOW_CUSTOMER_DEFAULT",
  ALLOW_CUSTOMER_CHOOSE_SESSION_AVAILABLE_SESSION:
    "ALLOW_CUSTOMER_CHOOSE_SESSION_AVAILABLE_SESSION",
  ALLOW_CUSTOMER_CHOOSE_BATCH: "ALLOW_CUSTOMER_CHOOSE_BATCH",
  ALLOW_CUSTOMER_CHOOSE_NEXT_AVAILABLE_BATCH:
    "ALLOW_CUSTOMER_CHOOSE_NEXT_AVAILABLE_BATCH",
  PRODUCT_QUANTITY_DEFAULT: `${MERCHANDISE_PRODUCT_QUANTITY}-DEFAULT`,
  ALLOW_CUSTOMER_CHOOSE_VARIATION: "ALLOW_CUSTOMER_CHOOSE_VARIATION",
  SESSION_VISIBLE_ON_BOOKING_PAGE: "SESSION_VISIBLE_ON_BOOKING_PAGE",
  LIMIT_SESSIONS: "LIMIT_SESSIONS",
  SLOT_UUID: "SLOT_UUID",
  CLASS_UUID: "CLASS_UUID",
};
